import { useCallback } from "react";
import { IUserSubprofileModel, userProfileHelper } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { useRouter } from "./useRouter";
import { useRedirectUrlParam } from "./useRedirectUrlParam";

export const useSwitchProfileWithRedirection = () => {
  const router = useRouter();
  const redirectUrl = useRedirectUrlParam();

  return useCallback(
    (subProfile?: IUserSubprofileModel) => {
      if (
        router.asPath.includes(ROUTES.SETTINGS_SCREEN) &&
        !subProfile?.Child
      ) {
        const settingPath = router.asPath.split("/").slice(-2).join("/");
        router.replace(settingPath, undefined, { withLoadingSplash: true });
      } else if (redirectUrl) {
        router.replace(redirectUrl, undefined, { withLoadingSplash: true });
      } else {
        const url = subProfile?.Child
          ? ROUTES.KIDS
          : userProfileHelper.getInitialHomePage(subProfile);

        router.replace(url, undefined, {
          withLoadingSplash: true,
        });
      }
    },
    [router.asPath]
  );
};
